import { createContext, useContext } from "react";

const ChatDataSourceContext = createContext(null);

export function ChatDataSourceProvider({ value, children }) {
  if (!value) {
    throw new Error("ChatDataSourceProvider requires a value prop.");
  }
  return (
    <ChatDataSourceContext.Provider value={value}>
      {children}
    </ChatDataSourceContext.Provider>
  );
}

export function useChatDataSource() {
  const context = useContext(ChatDataSourceContext);
  if (!context) {
    throw new Error("useChatDataSource must be used within ChatDataSourceProvider.");
  }
  return context;
}
